/* import { useStore } from "vuex";
const store = useStore(); */
import store from '@/store';
import { computed, ref } from "vue";
import Storage from '@/lib/storage';
const ss = new Storage('sessionStorage');
const Cookies = new Storage('cookie');

export default function getUserStage() {

    function getMemberInfo() {
        return new Promise((resolve, reject) => {
              G_transmit('getMemberInfo', {
                  name: 'getMemberInfo'
              }).then((res) => {
                //  memberUserV3.value = res.data || {};
                  resolve(res.data);
              })
        })  
      }

    // 全部备案信息
    const brand = computed(() => {
        // console.log('brand====', JSON.stringify(store.state.brand))
        return store.state.brand?.publishBrand || {};
    })
        
    // 具体配置信息
    const brandModulesV2 = computed(() => {
        // console.log('brandInfo====', JSON.stringify(brand.value?.brandConfig))
        return brand.value?.brandModulesV2 || {};
    })

    const portalTemplate = computed(() => {
        let portal = brandModulesV2.value.find(i => i.moduleKey == 'portal');
        let portalDefault = portal.children.find(i => i.moduleKey == 'portal:default');
        let portalTemplate = portalDefault.children.find(i => i.moduleKey == 'portal:default:template');
        return portalTemplate.moduleRuleList.find(i => i.checked);
    })
/* 
    let memberUserV3 = computed(() => {
        return store.state.memberUserV3 || {};
    }) */
    // let memberUserV3 = ref({});
    /* const stageSubjectGradeList = computed(() => {
        return memberUserV3.value.memberVo?.stageSubjectGradeList || [];
    }) */

    async function getStages(isLY) {
        let obj = {};
        if (isLY) {
            let accessToken = Cookies.getItem('X-DT-accessToken') || '';
            let memberInfo = accessToken ? await getMemberInfo() : { memberDetail: {stageSubjectGradeList: []} };
            let stageSubjectGradeList = memberInfo?.memberDetail?.stageSubjectGradeList || []
            let stages = stageSubjectGradeList.map(i=>i.stageId);
            let subjects = stageSubjectGradeList.map(i => i.subjectList);
            subjects = (subjects.flat()).map(i => i.subjectId);
            obj = {
                stageIds: stages.join(','),
                subjectIds: subjects.join(',')
            }
        }
        return obj;
    }

    return {
        portalTemplate,
        getStages
    }
}